import WarrantyListTableComponent from "./warrantyListTable.container";

export default WarrantyListTableComponent;
